import Service from "./Service";
const baseurl = '/api/formula-medica';
export default {
    store(obj) {
        return Service.post(`${baseurl}/store`, obj);
    },
    show(id) {
        return Service.get(`${baseurl}/show/${id}`);
    },
    showFormulaByHc(id_historia) {
        return Service.get(`${baseurl}/show-formula-hc/${id_historia}`);
    },
    showFormulaById(id) {
        return Service.get(`${baseurl}/show-formula-byId/${id}`);
    },
    delete(id) {
        return Service.delete(`${baseurl}/delete/${id}`);
    },
}